module.exports = 4321;


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/issue-387/file.js
 ** module id = 1
 ** module chunks = 0
 **/